import React from "react";
import ListArticle from "./ListArticle";
//import CardContentHome from "components/Frontend/Card/CardContentHome";

function Article() {
  return (
    <div className="details-header">
      <div className="container">
        <div className="row content-text mt-5 text-center">
          <div className="col-12 px-md-0 my-auto mb-3 mt-3">
            <h5 className="tagline">List Artikel</h5>
            <h1 className="headline mt-2">
              Artikel pilihan <br className="d-none d-md-block" />
            </h1>
          </div>
        </div>
        <ListArticle/>
        {/* <CardContentHome />
        <CardContentHome /> */}
        {/* <div className="row">
          <div className="text-center mt-4">
            <a href="#" className="btn btn-primary me-2">
              See All Categories
            </a>
            <a href="#" className="btn btn-outline-warning">
              Need help?
            </a>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Article;
